<template>
    <b-nav-text class="search-nav-item">
        <i class="fa fa-search search-icon" />

        <b-form-input
            :placeholder="$translate('filter_within_results')"
            :value="filterText"
            @update="filterByText"
        />
    </b-nav-text>
</template>

<script>
import { mapState } from 'vuex'
import { SLIDE_TIME_ATTRIBUTION } from '../../../business/const'

export default {
    name: 'SearchNavItem',
    data() {
        return {
            searchTimeout: null
        }
    },
    computed: {
        ...mapState({
            filterText: state => state.filter.filterText
        })
    },
    methods: {
        filterByText(value) {
            if (this.searchTimeout) {
                clearTimeout(this.searchTimeout)
            }
            this.searchTimeout = setTimeout(() => {
                this.searchTimeout = null
                this.$store.commit('filter/filterText', value)
            }, 100)
        }
    }
}
</script>

<style lang="scss" scoped>
.search-nav-item {
    position: relative;
    display: flex;
    align-items: center;
    color: $light;
    flex: 1;

    .search-icon {
        color: $light;
    }
    input {
        margin-left: 1rem;
        border: none;
        box-shadow: none;
        color: $light-3;
        background-color: transparent;
    }
}
</style>
